module.exports = __webpack_public_path__ + "static/media/3DPPA8.846dd6fc.jpg";